<template>
  <div class="tab-section">
    <div class="intro-section">
      <div class="resources-badge">What We Offer</div>

      <h2 class="section-title">{{ $t("whyChoose-heading") }}</h2>
      <p class="section-description">
        {{ $t("whyChoose-subheading") }}
      </p>
    </div>

    <div class="feature-grid">
      <div class="feature-card">
        <div class="card-icons">
          <span class="icon" v-html="institutionsIcons.searchIcon"></span>
          <div class="card-icon-separator"></div>
          <span class="icon" v-html="institutionsIcons.sheildIcon"></span>
        </div>
        <h3 class="feature-title">{{ $t("reason1-heading") }}</h3>
        <p class="feature-description">
          {{ $t("reason1-data") }}
        </p>
      </div>

      <div class="feature-card">
        <div class="card-icons">
          <span class="icon" v-html="institutionsIcons.clockIcon"></span>
          <div class="card-icon-separator"></div>
          <span class="icon" v-html="institutionsIcons.thunderIcon"></span>
        </div>
        <h3 class="feature-title">{{ $t("reason2-heading") }}</h3>
        <p class="feature-description">
          {{ $t("reason2-data") }}
        </p>
      </div>

      <div class="feature-card">
        <div class="card-icons">
          <span class="icon" v-html="institutionsIcons.paperSearchIcon"></span>
          <div class="card-icon-separator"></div>
          <span class="icon" v-html="institutionsIcons.documentsIcon"></span>
        </div>
        <h3 class="feature-title">{{ $t("reason3-heading") }}</h3>
        <p class="feature-description">
          {{ $t("reason3-data") }}
        </p>
      </div>

      <div class="feature-card">
        <div class="card-icons">
          <span class="icon" v-html="institutionsIcons.fingerPrintIcon"></span>
          <div class="card-icon-separator"></div>
          <span class="icon" v-html="institutionsIcons.globeIcon"></span>
        </div>
        <h3 class="feature-title">{{ $t("reason4-heading") }}</h3>
        <p class="feature-description">
          {{ $t("reason4-data") }}
        </p>
      </div>

      <div class="feature-card last">
        <div class="card-icons">
          <span class="icon" v-html="institutionsIcons.verifiedTickIcon"></span>
          <div class="card-icon-separator"></div>
          <span class="icon" v-html="institutionsIcons.planetIcon"></span>
        </div>
        <h3 class="feature-title">{{ $t("reason5-heading") }}</h3>
        <p class="feature-description">
          {{ $t("reason5-data") }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config";
import { institutionsIcons } from "@/assets/Icons/institutionsIcons.js";

export default {
  name: "WhyCredence",
  methods: {
    getCDNlink(fileKey) {
      let baseUrl = "";
      if (
        process.env.NODE_ENV === "development" ||
        process.env.NODE_ENV === "staging"
      ) {
        baseUrl = config.stagingCDN;
      } else if (process.env.NODE_ENV === "production") {
        baseUrl = config.prodCDN;
      }

      return `${baseUrl}${fileKey}`;
    },
  },
  data() {
    return {
      institutionsIcons,
    };
  },
};
</script>

<style scoped>
.tab-section {
  background: linear-gradient(78.13deg, #edf8ff, #eff1ff);
  display: flex;
  flex-direction: column;
  font-family: 'Figtree', sans-serif;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding: 80px;
}
.resources-badge {
  display: inline-block;
  padding: 12px 16px;
  color: #c94374;
  font-size: 0.875rem;
  font-weight: 600;
  border: 1px solid #c94374;
  border-radius: 50px;
  margin-bottom: 1.2rem;
  width: fit-content;
  background-color: #fff;
  letter-spacing: 1px;
}
.card-icons {
  border: 1px solid #1c1c1c;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 0px 19px;
  gap: 5px;
  margin: 0 auto;
}

.icon {
  margin: 4px 0px;
}

.card-icon-separator {
  width: 1px;
  height: 100%;
  background-color: #1c1c1c;
  margin: 0px 5px;
}

.intro-section {
  margin-bottom: 40px;
  width: 90%;
  gap: 16px;
}

.section-title {
  background: linear-gradient(-72.07deg, #0172f4 19%, #224096 64%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 40px;
  font-weight: 700;
  line-height: 3.2rem;
  margin: 0;
}

.section-description {
  color: #3e4855;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  margin-top: 16px;
  max-width: 861px;
  margin: 0 auto;
}

.feature-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: center;
  width: 90%;
}

.feature-card {
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0px 1px 11px rgba(17, 54, 90, 0.2);
  flex: 1;
  min-width: 28%;
  padding: 40px 24px;
  text-align: center;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 25px;
  /* height: -webkit-fill-available; */
}

.last {
  max-width: 46%;
}

.feature-image {
  width: 64px;
  height: 64px;
  object-fit: contain;
  margin: 0 auto;
}

.feature-title {
  font-size: 24px;
  font-weight: 600;
  color: #1c1c1c;
  margin: 0;
}

.feature-description {
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  color: #1c1c1c;
  margin: 0;
}

@media only screen and (max-width: 1024px) {
  .section-title {
    font-size: 36px;
  }
  .section-description {
    font-size: 16px;
  }
  .feature-title {
    font-size: 22px;
  }
  .feature-image {
    width: 50px;
    height: 50px;
  }
  .feature-card {
    padding: 25px 20px;
  }
  .tab-section{
    padding: 40px 20px;
  }
}

@media only screen and (max-width: 768px) {
  .tab-section {
    padding: 40px;
  }
  .intro-section {
    width: 100%;
  }
  .section-title {
    font-size: 36px;
  }
  .section-description {
    font-size: 16px;
    margin-top: 20px;
  }
  .feature-title {
    font-size: 20px;
  }
  .feature-image {
    width: 50px;
    height: 50px;
  }
  .feature-grid {
    width: -webkit-fill-available;
  }
  .feature-card {
    padding: 25px 20px;
    flex: auto;
  }
  .feature-description {
    font-size: 16px;
  }
  .last {
    max-width: none;
  }
}

@media only screen and(max-width: 480px) {
  .section-title{
    font-size: 36px;
  }
}
</style>
